import { runClientComponent } from '../../_common/client/client-component-runner';
import { UiAggregatorComponent } from './ui-aggregator.component';

runClientComponent({ UiAggregatorComponent });
